import { useEffect, useState } from 'react';
import { useLazyQuery, useQuery } from 'data-fetching-client';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { DELETE_WEBHOOK_DEFINITION, GET_WEBHOOK_DEFINITIONS, UPDATE_WEBHOOK_DEFINITION } from 'automation-ui-enrollment/queries/WebhookQueries';
import WebhookWizard from 'automation-ui-enrollment/components/eventEnrollment/WebhookWizard';
import WebhookSelectionView from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookSelectionView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookSelectionAlertStore = FloatingAlertStore.newFloatingAlertStore();
const WebhookManagementView = ({
  objectTypeId,
  onSelectWebhook
}) => {
  const {
    loading,
    error,
    data,
    refetch
  } = useQuery(GET_WEBHOOK_DEFINITIONS);
  const [deleteWebhookDefinition, {
    error: deleteWebhookError,
    called: deleteWebhookCalled,
    loading: deleteWebhookLoading
  }] = useLazyQuery(DELETE_WEBHOOK_DEFINITION);
  const [updateWebhookDefinition, {
    error: updateWebhookError,
    called: updateWebhookCalled,
    loading: updateWebhookLoading
  }] = useLazyQuery(UPDATE_WEBHOOK_DEFINITION, {
    nextFetchPolicy: 'network-only',
    fetchPolicy: 'network-only'
  });
  const [showWizard, setShowWizard] = useState(false);
  const onWizardClose = () => {
    setShowWizard(false);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    refetch();
  };
  const handleWebhookSelect = (webhook, isNewWebhook = false) => {
    if (isNewWebhook) {
      WebhookSelectionAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.createSuccess.description"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.createSuccess.title"
        }),
        type: 'success'
      });
    }
    onSelectWebhook(webhook);
  };
  const handleWebhookUpdate = webhookDefinition => {
    updateWebhookDefinition({
      variables: {
        webhookDefinition
      }
    });
  };
  const handleWebhookDelete = definitionId => {
    deleteWebhookDefinition({
      variables: {
        definitionId
      }
    });
  };

  // Handle delete webhook response/errors
  useEffect(() => {
    if (deleteWebhookError) {
      WebhookSelectionAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.deleteError.description"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.deleteError.title"
        }),
        type: 'danger'
      });
    } else if (deleteWebhookCalled && !deleteWebhookLoading) {
      WebhookSelectionAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.deleteSuccess.description"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.deleteSuccess.title"
        }),
        type: 'success'
      });
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      refetch();
    }
  }, [deleteWebhookError, deleteWebhookLoading, deleteWebhookCalled, refetch]);

  // Handle update webhook response/errors
  useEffect(() => {
    if (updateWebhookError) {
      WebhookSelectionAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.updateError.description"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.updateError.title"
        }),
        type: 'danger'
      });
    } else if (updateWebhookCalled && !updateWebhookLoading) {
      WebhookSelectionAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.updateSuccess.description"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.alerts.updateSuccess.title"
        }),
        type: 'success'
      });
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      refetch();
    }
  }, [updateWebhookError, updateWebhookCalled, updateWebhookLoading, refetch]);
  if (error) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.events.webhookEvents.error.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.events.webhookEvents.error.description"
      })
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    });
  }
  const webhooks = data.webhookDefinitions.results;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFloatingAlertList, {
      use: "contextual",
      alertStore: WebhookSelectionAlertStore
    }), /*#__PURE__*/_jsx(WebhookSelectionView, {
      webhooks: webhooks,
      objectTypeId: objectTypeId,
      setShowWizard: setShowWizard,
      handleWebhookDelete: handleWebhookDelete,
      handleWebhookSelect: handleWebhookSelect,
      handleWebhookUpdate: handleWebhookUpdate
    }), showWizard && /*#__PURE__*/_jsx(WebhookWizard, {
      objectTypeId: objectTypeId,
      onClose: onWizardClose
    })]
  });
};
export default WebhookManagementView;